import { createFileRoute } from '@tanstack/react-router';
import { JourneysPersonSegmentsRoute } from './-route-wrappers';

/**
 * `/journeys/people/:personId/segments` — the address the embedded app's tab bar links to. Flag on,
 * it forwards to Belongs to at the tab's own URL; flag off, the embedded app serves it in place and
 * opens Belongs to itself.
 */
function JourneysPersonSegmentsIndexRoute() {
  const { personId } = Route.useParams();

  return <JourneysPersonSegmentsRoute personId={personId} view="belongs" />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/people/$personId/segments/')({
  component: JourneysPersonSegmentsIndexRoute,
});
